import * as frontend from "./frontend";
import defaultSheet from "./common/default-sheet";

const MusicSheet = {
  // ...sheetsMethod,
  defaultSheet,
  frontend
};

export default MusicSheet;
export { defaultSheet };
